import { remove } from "lodash";

const key = "deny-all-compliance";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]+\/security$/);
};

const modify = (resp) => {
	if(resp.data.Success !== true || !resp.data.Data) {
		return;
	}
	
	const assigned = resp.data.Data.Assigned;
	const role = resp.data.Data.Roles.find(r => r.Code === assigned[0].Code);
	remove(role.Actions, a => a.Path.indexOf("compliance") > -1);

	const newDeny = { Effect: "Deny", Path: "/reporting/compliance/**/*" };
	role.Actions.push(newDeny);

};

export const  denyAllCompliance = [key, applicable, modify];